import PageBanner from "@/components/data-display/pageBanner";
import MetaData from "@/components/seo/MetaData";
import { RobodocInfo } from "@/utils/constants";

function PrivacyPolicy() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/terms-of-use`;

  return (
    <>
      <MetaData url={pageUrl} />

      <PageBanner
        bannerText="শর্তাবলী"
        secondText="সর্বশেষ আপডেট: ২০ জানুয়ারী, ২০২৩"
      />

      <div className="container mb-[5.656rem] mt-[2rem] space-y-[3rem]">
        <div>
          <p className="text-[1.125rem] font-bold">১। শর্তাবলীর সম্মতি</p>

          <p className="mt-[1.25rem]">
            {RobodocInfo.domain} এর সমস্ত ওয়েবপেজ {RobodocInfo.domain} এর
            মালিকানাধীন এবং পরিচালিত যা নিচে বর্ণিত শর্তাবলীর অধীনে আপনি ব্রাউজ
            করছেন। ওয়েবসাইট ব্যবহার করার আগে নিয়মাবলীগুলো অবশ্যই পরে নিন। সাইটে
            প্রবেশ, বিষয়বস্তু দেখা ও আমাদের সেবাগুলো (যা নিচে উল্লেখিত আছে)
            ব্যবহার করার মাধ্যমে আপনি নিচের শর্তাবলীতে সম্মতি জানাচ্ছেন বলে গণ্য
            হবে। শর্তাবলীর পাশাপাশি আমাদের গোপনীয়তা, রিটার্ন এবং ডেলিভারির
            পলিসি এর মধ্যে অন্তর্ভুক্ত। এই শর্তাবলী এবং বিক্রয়ের শর্তাবলী যেকোন
            নথিতে থাকা অন্যান্য শর্তগুলির উপর অগ্রাধিকার পাবে যদি না পূর্বে
            লিখিতভাবে প্রকাশ করা হয়।।
          </p>
        </div>
        <div>
          <p className="text-[1.15rem] font-bold">২। প্রোডাক্ট </p>

          <p className="mt-[1.25rem]">
            RoboDoc এর গ্রাহকদের জন্য অফার করা বেশিরভাগ প্রোডাক্ট আমাদের স্টকে
            পাওয়া যায়*।
          </p>
        </div>
        <div>
          <p className="text-[1.15rem] font-bold">৩। অর্ডার সম্পর্কে </p>

          <p className="mt-[1.25rem]">
            অটোমেটেড এন্ট্রি সিস্টেমটি প্রমাণ হিসেবে বিবেচিত হবে যা দ্বারা
            অর্ডার এর ধরন, বিষয়বস্তু ও তারিখ প্রমাণিত হবে। RoboDoc গ্রাহকের দেয়া
            ইমেইলে/ফোন নম্বরে একটি কনফার্মেশন মেসেজ পাঠিয়ে অর্ডার নিশ্চিত করবে।
            গ্রাহকের কাছে অর্ডারটি কনফার্ম হবার পরবর্তীতে বিক্রয় প্রক্রিয়াটি
            সম্পন্ন হবে। যদিও আমরা ইমেইলের মাধ্যমে অর্ডার কনফার্মেশন প্রদান করি,
            তবে একটি অর্ডার ই-মেইল প্রাপ্তি আমাদের পক্ষ থেকে অর্ডার গ্রহণ বা
            প্রোডাক্ট ও সেবা বিক্রির নিশ্চিতকরণ নয়। RoboDoc পূর্ব নোটিশ ছাড়াই
            অর্ডারের পরিমাণ কমানো, বাতিল‌ অথবা প্রত্যাখ্যানের অধিকার সংরক্ষণ
            করে, বিশেষ করে যদি কোনো গ্রাহকের সাথে পূর্বে অর্ডারের পেমেন্ট নিয়ে
            বিরোধ থেকে থাকে অথবা অন্য কোনো অনিবার্য কারণে।
          </p>
        </div>
        <div>
          <p className="text-[1.15rem] font-bold">৪। তথ্যের সঠিকতা </p>

          <p className="mt-[1.25rem]">
            আমরা সবসময় নিশ্চিত করার চেষ্টা করি আমাদের ওয়েবসাইটে দেওয়া তথ্যগুলি
            সঠিক, সম্পূর্ণ ও নতুন। আমাদের এই প্রচেষ্টার সত্ত্বেও, কখনো
            ওয়েবসাইটের তথ্য অসম্পূর্ণ, ভুল বা পুরানো হতে পারে। কিছু ক্ষেত্রে
            ওয়েবসাইটে প্রদর্শিত প্রোডাক্ট নাও থাকতে পারে, ছবির চেয়ে কিছুটা
            আলাদা হতে পারে, প্রোডাক্টের বৈশিষ্টের সাথে অমিল থাকতে পারে অথবা খুব
            কম ক্ষেত্রে প্রোডাক্টটি উল্লিখিত প্রোডাক্টের চেয়ে ভিন্ন মূল্য বা
            ভিন্ন দেখাতে পারে। আমরা কোনো পূর্ব নোটিশ ছাড়াই মূল্য, ফিচার, বর্ণনা
            এবং পরিমান পরিবর্তন করে থাকি।
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">৫। ডেলিভারি</p>
          <p className="mt-[1.25rem]">
            অর্ডার নেওয়ার পর আমরা গ্রাহকের নির্ধারিত ঠিকানায় বাংলাদেশের ভিতরে
            ডেলিভারি করে থাকি। ঢাকায় আমাদের সাধারণত এক কর্মদিবসের মধ্যে অর্ডার
            ডেলিভারি সম্পন্ন হয়ে থাকে। দুপুর ৩:০০ টার এর আগে অর্ডার করলে আপনার
            পর দিন প্রোডাক্টটি পাওয়ার সম্ভাবনা থাকে। ধরুন, আপনি ১২ই জানুয়ারী
            সকাল ১০:০০ টায় কিছু ইকুইপমেন্ট অর্ডার করেছেন তাহলে আপনি আপনার
            প্রোডাক্টটি ১৩ই জানুয়ারীতে পাবেন*। ১৩ জানুয়ারীতে প্রোডাক্টটি পেতে
            আপনাকে অবশ্যই ১২ জানুয়ারী দুপুর ৩ টার এর আগে অর্ডার করতে হবে এবং
            কোন পরিবর্তন থাকলে এই সময়ের মধ্যেই করতে হবে। এটি অবশ্যই স্টকে থাকা
            প্রোডাক্টের জন্য প্রযোজ্য। অনিবার্য পরিস্থিতির কারণে ডেলিভারিতে দেরি
            হতে পারে। বহন করার সময় যদি প্রোডাক্টটি ভেঙ্গে যায় বা ক্ষতিগ্রস্ত
            হয় সেক্ষেত্রে আমরা সম্পূর্ণ দায়ভার বহন করব। তবে প্রোডাক্ট ভাল
            অবস্থায় ডেলিভার করার পরে, সেগুলি পরিচালনা করার সম্পূর্ণ দায়িত্ব
            গ্রাহকের।
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">‘সুপার ফাস্ট ডেলিভারি’</p>

          <p className="mt-[1.25rem]">
            সুপার ফাস্ট ডেলিভারি’ মানে অর্ডার কনফার্মেশনের সময় থেকে পরবর্তী ৪
            ঘন্টার মধ্যে অর্ডার ডেলিভারি করা হবে। এটি বর্তমানে ঢাকা শহরের কিছু
            নির্ধারিত অঞ্চলে পাওয়া যাচ্ছে। এই অর্ডারগুলো জরুরিভিত্তিতে ও সময়ের
            মধ্যে ডেলিভারি করা হয়। যদি আপনার অর্ডার দেওয়ার সময় থেকে পরবর্তী ৪
            ঘন্টার মধ্যে অর্ডারটি ডেলিভারি না করা হয়, তাহলে আপনি কোন ডেলিভারি
            চার্জ ছাড়াই ডেলিভারি পাবেন! সুপার ফাস্ট ডেলিভারি শুধুমাত্র
            কর্মদিবসের সকাল ৮:০০ টা থেকে সন্ধ্যা ৭:০০ টা পর্যন্ত প্রযোজ্য।
            উদাহরণস্বরূপ: আপনি যদি সকাল ১০:০০ টায় অর্ডার করেন তবে আপনি এটি
            দুপুর ২:০০ টার মধ্যে পেয়ে যাবেন। আবহাওয়া, ধর্মঘট ইত্যাদির মতো
            অনিবার্য পরিস্থিতিতে ডেলিভারি দেরি হতে পারে এবং আপনাকে অবশ্যই
            ডেলিভারির সময় উল্লেখিত ঠিকানায় উপস্থিত থাকতে হবে
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">৬। মূল্য</p>

          <p className="mt-[1.25rem]">
            ডেলিভারি খরচ প্রোডাক্টের দামের অন্তর্ভুক্ত নয়। অর্ডার কনফার্মেশনে
            উল্লেখিত মূল্যটি চূড়ান্ত যা প্রযোজ্য ট্যাক্স, ভ্যাট, ডেলিভারি এবং
            প্রোডাক্টের খরচ, প্যাকেজিং ও সংরক্ষণের অন্তর্ভুক্ত।
          </p>
        </div>
        <div>
          <p className="text-xl font-bold">৭। পেমেন্ট পলিসি</p>

          <p className="word-wrap text mt-[1.25rem] break-words">
            যদি আপনি আমাদের থেকে ক্রয়কৃত প্রোডাক্টে সন্তুষ্ট না হয়ে থাকেন বা
            অন্যান্য সমস্যা থাকে, অনুগ্রহ করে যত তাড়াতাড়ি সম্ভব আমাদের ইমেইল
            করুন {RobodocInfo.email1} এই ইমেইলে অথবা কল করুন&nbsp;
            {RobodocInfo.phoneBn} নম্বরে। আপনার অর্ডারকৃত প্রোডাক্টের পরিবর্তে
            অন্য প্রোডাক্ট হয়ে থাকলে অথবা প্রোডাক্টটিতে কোনো ত্রুটি অথবা নষ্ট
            অথবা পরিবহনের সময় কোনো প্রকার ক্ষতিগ্রস্ত হলে, আপনি প্রোডাক্টটি ফেরত
            দিতে পারবেন। আমরা ২৪ ঘন্টা এর মধ্যে ফেরৎ গ্রহণ করি যদি প্রোডাক্টটি
            IC, ডেভেলপমেন্ট বোর্ড, টুল, ক্যাবল ইত্যাদি হয়ে থাকে এবং অক্ষত
            অবস্থায় ও চালানো না হয়ে থাকে। এই সময়ের পরে, বিক্রয় চূড়ান্ত হিসাবে
            বিবেচিত হবে। আমরা ক্রয়কৃত প্রোডাক্ট যা চালানো, প্রোগ্রাম করা,
            পরিবর্তিত বা গ্রাহক দ্বারা কোনোভাবে ক্ষতি হয়েছে, সেইসব প্রোডাক্ট
            রিটার্ন গ্রহণ করি না৷
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">৮। রিটার্ন/ফেরত পলিসি</p>

          <p className="word-wrap text mt-[1.25rem] break-words">
            যদি আপনি আমাদের থেকে ক্রয়কৃত প্রোডাক্টে সন্তুষ্ট না হয়ে থাকেন বা
            অন্যান্য সমস্যা থাকে, অনুগ্রহ করে যত তাড়াতাড়ি সম্ভব আমাদের ইমেইল
            করুন {RobodocInfo.email1} এই ইমেইলে অথবা কল করুন&nbsp;
            {RobodocInfo.phoneBn} নম্বরে। আপনার অর্ডারকৃত প্রোডাক্টের পরিবর্তে
            অন্য প্রোডাক্ট হয়ে থাকলে অথবা প্রোডাক্টটিতে কোনো ত্রুটি অথবা নষ্ট
            অথবা পরিবহনের সময় কোনো প্রকার ক্ষতিগ্রস্ত হলে, আপনি প্রোডাক্টটি ফেরত
            দিতে পারবেন। আমরা ২৪ ঘন্টা এর মধ্যে ফেরৎ গ্রহণ করি যদি প্রোডাক্টটি
            IC, ডেভেলপমেন্ট বোর্ড, টুল, ক্যাবল ইত্যাদি হয়ে থাকে এবং অক্ষত
            অবস্থায় ও চালানো না হয়ে থাকে। এই সময়ের পরে, বিক্রয় চূড়ান্ত হিসাবে
            বিবেচিত হবে। আমরা ক্রয়কৃত প্রোডাক্ট যা চালানো, প্রোগ্রাম করা,
            পরিবর্তিত বা গ্রাহক দ্বারা কোনোভাবে ক্ষতি হয়েছে, সেইসব প্রোডাক্ট
            রিটার্ন গ্রহণ করি না৷
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">৯। ওয়ারেন্টি</p>

          <p className="mt-[1.25rem]">
            গ্রাহকের সন্তুষ্টি আমাদের সাফল্যের চাবিকাঠি। গ্রাহকের সর্বোচ্চ
            সন্তুষ্টি নিশ্চিত করার জন্য আমরা সর্বোত্তম চেষ্টা করি। যদি কোনো
            নির্দিষ্ট পণ্যের কোনো ওয়ারেন্টি থাকে সেক্ষেত্রে ওয়ারেন্টি
            প্রযোজ্য।
          </p>
        </div>
        <div>
          <p className="text-xl font-bold">১০। অননুমোদিত ব্যবহার</p>

          <p className="mt-[1.25rem]">
            ওয়েবসাইটটি বাণিজ্যিক, প্রচার কিংবা ওয়েবসাইটের কোন বিষয়বস্তু, কোড,
            ডেটা বা উপকরণ ব্যবহার করা নিষিদ্ধ যদি না আপনি RoboDoc এর অনুমোদিত
            কর্মীদের কাছ থেকে স্পষ্ট ও পূর্বে লিখিত অনুমতি পেয়ে থাকেন । এখানে
            স্পষ্টভাবে অনুমোদিত ব্যতীত, আপনি ওয়েবসাইটটির সাথে জড়িত কোন
            ডাউনলোড, পোস্ট, বিবরণ, প্রদর্শন, প্রকাশ, অনুলিপি, প্রেরণ, পরিবর্তন,
            সম্পাদন, সম্প্রচার, স্থানান্তর, বা কোনো সামগ্রী, ডেটা বা উপকরণ
            বিক্রি বা অপব্যবহার করতে পারবেন না।
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">১১। তৃতীয় পক্ষের ওয়েবসাইট</p>

          <p className="mt-[1.25rem]">
            আমরা কিছু সময় ওয়েবসাইটে তৃতীয় পক্ষের লিঙ্ক অন্তর্ভুক্ত করে থাকি।
            এই তৃতীয় পক্ষের সাইটগুলির আলাদা এবং নিজস্ব গোপনীয়তা নীতি রয়েছে৷
            তাই এই লিঙ্কযুক্ত সাইটগুলির বিষয়বস্তু এবং কার্যকলাপের ক্ষেত্রে
            আমাদের কোন দায় নেই। তবুও, আমরা আমাদের সাইটের বিশ্বাস্যতা রক্ষা করার
            জন্যে এই সাইটগুলি সম্পর্কে যেকোন প্রতিক্রিয়াকে স্বাগত জানাই।
            এছাড়াও, RoboDoc কোনো লিঙ্কযুক্ত ওয়েবসাইট থেকে প্রাপ্ত কোনো ধরনের
            ট্রান্সমিশনের জন্য দায়ী নয়। আপনার তৃতীয় পক্ষের ওয়েবসাইটের উপর
            নির্ভরতা হয়ে থাকবে আপনার নিজ দায়িত্বে।
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">১২। নিবন্ধন</p>

          <p className="mt-[1.25rem]">
            আপনি সেবাগুলি সম্পূর্ণ ভাবে গ্রহণ করতে চাইলে আপনাকে ওয়েবসাইটে একটি
            অ্যাকাউন্ট তৈরি করতে হবে। আপনি অতিথি হিসাবেও প্রোডাক্ট কিনতে পারেন।
            অতিথি হিসেবে প্রোডাক্ট কিনতে হলে আপনার একটি বৈধ ইমেইল অ্যাড্রেস,
            বিলিং ও ডেলিভারির জন্য তথ্য দিতে হবে। সমস্ত সেবা গ্রহণ করতে, আপনাকে
            অবশ্যই একটি অ্যাকাউন্ট খুলতে হবে এবং একটি পাসওয়ার্ড সেট করতে হবে৷
            আপনার অ্যাকাউন্ট এবং পাসওয়ার্ডের নিরাপত্তা এবং গোপনীয়তা বজায় রাখা
            দায়িত্ব সম্পূর্ণ আপনার। নিবন্ধনে স্পষ্টভাবে মনোনীত ছাড়া অন্যান্য
            তথ্য বাধ্যতামূলক নয়। ইচ্ছাকৃতভাবে মিথ্যা নিবন্ধন তথ্য দেওয়া
            শর্তাবলী লঙ্ঘন হিসেবে গণ্য হবে যার ফলে আপনার RoboDoc অ্যাকাউন্টটি
            বন্ধ করা হতে পারে।
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">১৩। শর্তাবলী পুনর্বিবেচনা</p>

          <p className="mt-[1.25rem]">
            এই শর্তাবলীটি যেকোনো সময় সংশোধন কিংবা আপডেট হতে পারে। আপনি পেজটি
            সচরাচর ভিজিট করে শর্তাবলীর আপডেটগুলি জেনে রাখতে পারবেন যেহেতু এ
            শর্তাবলী বাধ্যতামূলক। শর্তাবলীর কিছু বিধান আইনি নোটিশ বা ওয়েবসাইটের
            নির্দিষ্ট পেজে দেওয়া শর্তাবলী দ্বারা সংশোধন হতে পারে।
          </p>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
